import * as React from 'react';
import withIconSvg from '../helpers/withIconSvg';

const Icon: React.FC = (props) => (
	<svg
		width="52"
		height="28"
		viewBox="0 0 52 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<rect x="1" y="0.5" width="50" height="27" rx="13.5" fill="white"/>
		<rect x="1" y="0.5" width="50" height="27" rx="13.5" stroke="#86E4E9"/>
		<path d="M22.3871 13.9072C22.3871 15.5524 21.9177 16.8125 20.9789 17.6875C20.0446 18.5625 18.6934 19 16.9252 19H14.0951V9.00586H17.2328C18.8643 9.00586 20.1312 9.43652 21.0336 10.2979C21.9359 11.1592 22.3871 12.3623 22.3871 13.9072ZM20.1859 13.9619C20.1859 11.8154 19.238 10.7422 17.3421 10.7422H16.2142V17.25H17.1234C19.1651 17.25 20.1859 16.154 20.1859 13.9619ZM27.3193 12.6973C26.8773 12.6973 26.5309 12.8385 26.2803 13.1211C26.0296 13.3991 25.8861 13.7956 25.8496 14.3105H28.7754C28.7663 13.7956 28.6318 13.3991 28.3721 13.1211C28.1123 12.8385 27.7614 12.6973 27.3193 12.6973ZM27.6133 19.1367C26.3828 19.1367 25.4212 18.7972 24.7285 18.1182C24.0358 17.4391 23.6895 16.4775 23.6895 15.2334C23.6895 13.9528 24.0085 12.9639 24.6465 12.2666C25.2891 11.5648 26.1755 11.2139 27.3057 11.2139C28.3857 11.2139 29.2266 11.5215 29.8281 12.1367C30.4297 12.752 30.7305 13.6019 30.7305 14.6865V15.6982H25.8018C25.8245 16.2907 26 16.7533 26.3281 17.0859C26.6562 17.4186 27.1165 17.585 27.709 17.585C28.1693 17.585 28.6045 17.5371 29.0146 17.4414C29.4248 17.3457 29.8532 17.193 30.2998 16.9834V18.5967C29.9352 18.779 29.5456 18.9134 29.1309 19C28.7161 19.0911 28.2103 19.1367 27.6133 19.1367ZM34.1041 19L31.192 11.3574H33.3727L34.8493 15.7119C35.0133 16.2633 35.1159 16.7852 35.1569 17.2773H35.1979C35.2207 16.8398 35.3232 16.318 35.5055 15.7119L36.9752 11.3574H39.1559L36.2438 19H34.1041Z" fill="#002838"/>
	</svg>
);

export default withIconSvg(
	Icon,
	false,
	{
		tags: [
			'environment',
			'development',
			'badge',
			'unicorn',
		],
	},
);
